/* tslint:disable */
import { Coordinates } from './coordinates';
import { ViewProductSection_result } from './view-product-section-_result';

/**
 */
export class ViewProductSection {
    axeTemp?: number[];
    dataChart?: Coordinates[];
    resultLabel?: number[];
    result?: ViewProductSection_result;
    imageProductSection?: string;
}



// WEBPACK FOOTER //
// /home/dfm/cryosoft/ui/src/app/api/models/view-product-section.ts